import { createAction } from "../../utils";
import { MODAL_CLOSE } from "../../constants";

const modalClose = createAction(MODAL_CLOSE);

export const closeModal = () => (dispatch) => {
  dispatch(modalClose());
};
